import * as angular from 'angular';
import {IController, IQService, ITimeoutService} from 'angular';
import * as _ from "lodash";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentsService} from "../../services/agents-service.service";
import {AgentModel} from "../../angular/models/agent.model";
import {ServiceAreasService} from "../../../service-areas/services/service-areas-service.service";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {$agentsFactory} from "../../$agents.factory";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {ServicesService} from "../../../deliveries/services/services-service.service";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {LeanPlanningAlertsService} from "../../../lean-planning/services/lean-planning-alerts.factory";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ScheduleDialogService} from "../../../schedule/services/schedule-dialog.service";
import {ScheduleService} from "../../../schedule/services/schedule-service.service";
import {AgentsPaginationQueryModel} from "../../angular/models/agents-pagination-query.model";
import {AgentType} from "../../types/agent.type";
import {AgentStatusType} from "../../types/agentStatus.type";
import {EmploymentType} from "../../types/employment.type";
import {AgentsPaginationDataModel} from "../../angular/models/agents-pagination-data.model";
import {TaskModel} from "../../../tasks/models/task.model";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {RoutesListPayloadModel} from "../../../routes/models/routes-list-payload.model";
import {AgentsContextService} from "../../services/agents-context.service";
import {TasksFacadeService} from "../../../tasks/angular/services/tasks-facade.service";
import {Subscription} from "rxjs";
import {ServiceStatus} from "../../../deliveries/constants/service-status.type";
import {AgentScheduleExtraDataRequestModel} from "../../../schedule/models/agent-schedule-extra-data-request.model";
import {AgentScheduleExtraDataRequestType} from "../../../schedule/types/agent-schedule-extra-data-request.type";
import {RouteModel} from "../../../routes/models/route.model";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {RouteEditValidationResultEnum} from "../../../lean-planning/types/route-edit-validation-result.enum";

export class AgentsScheduleViewNewCtrl implements IController {

  agentsGroup: any;
  from: any;
  to: any;
  size: number;
  page: number;
  branchIds: string[];
  agentIds: string[];
  serviceAreaIds: any;
  agentType: any;
  agentSkills: any;
  agentAssistant: any;
  isFavouriteAgentsMode: boolean
  isSortMode: boolean
  viewSettings: ViewSettingsModel;
  selectedQuickFilterId: string;

  private agentsRef: any;
  private routesRef: any;
  private servicesRef: any;
  private tasksRef: any;
  private serviceAreasRef: any;
  private siteId: string;
  public loadingRoutes: boolean;
  public isLoadingCreateShift: boolean;
  private configZoneId: string;
  private shiftActions: any;
  private taskActions: any;
  private breakActions: any;
  public pagenationPages: any;
  public schedules: any;
  public routes: any;
  public tasks: TaskModel[];
  public serviceAreas: any;
  public agentsSearchTerm: string;
  public pageName: string;
  public selectedRoute: RouteModel;

  private filtersConfig: any;
  private range: any;
  private agentTypes: any;
  private totals: any;
  private routesRefList: any;


  public selectedShift: any;
  public selectedShiftTemplate: any;
  public selectedShiftDate: any;
  public selectedShiftAgent: AgentModel;
  public isEditShiftEnabled: boolean;
  public highlightedShifts: any;
  public highlightedTasks: any;
  public highlightedRoutes: any[];
  public loading: boolean = false;
  private pushesTimeoutRef: any;
  private maxUserIdleTimeMinutes: number;
  private validateRouteAssignment: boolean;

  public paginationData: AgentsPaginationDataModel;
  public paginationPages: number[];
  public isTooltipsEnabled: boolean = true;
  public isShowScheduleContentEnabled: boolean = true;
  public isShowTaskColorByAgent: boolean = true;
  public isShowUtilization: boolean = false;
  public selectedTab: string; // SERVICES/MAP
  public selectedServices: any[] = [];
  public favouriteAgentIds: string[];
  public tasksSubscription: Subscription;

  constructor(private agentConstants, private $route, private $filter, private commonsService: CommonsService,
              private agentRequests: AgentRequests, private scheduleService: ScheduleService, private bringozLoaderService: BringozLoaderService,
              private $task, private $timeout: ITimeoutService, private $mdSelect, private scheduleDialogService: ScheduleDialogService, private confirmDialogService: ConfirmDialogService,
              private commonsDialogService: CommonsDialogService, private deliveriesDialogService: DeliveriesDialogService, private TimelineService, private quickFilterContextService: QuickFilterContextService,
              private leanPlanningService: LeanPlanningService, private leanPlanningAlertsService: LeanPlanningAlertsService, private routesService: RoutesService, private $delivery,
              private $serviceArea, private $log, private $q: IQService, private moment, private dateRangeTimeFiltersService: DateRangeTimeFiltersService,
              private servicesService: ServicesService, private agentsContextService: AgentsContextService,
              private serviceAreasService: ServiceAreasService, private tasksFacadeService: TasksFacadeService,
              private $agents: $agentsFactory, private agentsService: AgentsService, private splitService, private $state,
              private viewSettingsService: ViewSettingsService,
              private analyticsService: AnalyticsService, private viewFilterSettingsService: ViewFilterSettingsService) {
    this.pageName = this.$state.current.name;
    this.agentsRef = this.$agents();
    this.routesRef = this.$route();
    // this.tasksRef = this.$task();
    this.servicesRef = this.$delivery();
    this.serviceAreasRef = this.$serviceArea();
    this.configZoneId = this.splitService.getTimeZone();
    this.maxUserIdleTimeMinutes = this.splitService.maxUserIdleTimeMinutes();
    this.validateRouteAssignment = this.splitService.getValidateRouteAssignment();

    this.shiftActions = [
      {key: 'EDIT', name: 'Edit shift'},
      {key: 'EDIT_BREAK', name: 'Edit shift break', nameMany: 'Edit shifts breaks'},
      {key: 'EDIT_NOTES', name: 'Edit shift notes', nameMany: 'Edit shifts notes'},
      {key: 'DELETE', name: 'Delete shift', nameMany: 'Delete shifts'}
    ];
    this.taskActions = [
      {key: 'ASSIGN_ROUTE', name: 'Assign Route', icon: 'assign', permission: 'planning.routes.update'},
      {key: 'REOPTIMIZE_ROUTE', name: 'Reoptimize Route', icon: 'reoptimize', permission: 'planning.routes.update'},
      {key: 'RESET_ROUTE', name: 'Reset Route', icon: 'reset', permission: 'planning.routes.update'},
      {key: 'DELETE_ROUTE', name: 'Delete Route', icon: 'trash', permission: 'planning.routes.delete'}
    ];
    this.breakActions = [
      {key: 'EDIT', name: 'Edit break', nameMany: 'Edit breaks', icon: 'edit'},
      {key: 'EDIT_NOTES', name: 'Edit shift notes', nameMany: 'Edit shifts notes', icon: 'edit'},
      {key: 'DELETE', name: 'Delete Break', nameMany: 'Delete Breaks', icon: 'trash'}
    ];
  }

  $onInit() {
    const range = this.from && this.to ? {
      dateStart: this.from,
      dateEnd: this.to
    } : this.dateRangeTimeFiltersService.today();

    this.agentTypes = this.agentConstants.types;
    this.siteId = this.splitService.getSiteId();
    this.loadingRoutes = false;
    this.isLoadingCreateShift = false;
    this.favouriteAgentIds = angular.copy(this.agentsContextService.getFavouriteAgentIds());

    this.filtersConfig = {
      range: range,
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      queryString: undefined,
      includeFilters: [
        SiteFiltersType.branchIds,
        SiteFiltersType.serviceAreaIds,
        SiteFiltersType.agentIds,
        SiteFiltersType.agentType,
        SiteFiltersType.agentStatus,
        SiteFiltersType.agentAssistant
      ],
      bringozFilters: {
        [SiteFiltersType.branchIds]: this.branchIds || [],
        [SiteFiltersType.serviceAreaIds]: this.serviceAreaIds || [],
        [SiteFiltersType.agentIds]: this.agentIds || [],
        [SiteFiltersType.agentType]: this.agentType,
        [SiteFiltersType.agentStatus]: this.agentsGroup,
        [SiteFiltersType.agentAssistant]: this.agentAssistant
      }
    }

    if (!this.size) {
      this.size = 10;
    }
    if (!this.page) {
      this.page = 0;
    }

    this.routesRefList = {};
    this.schedules = [];
    this.tasks = [];
    this.highlightedShifts = [];

    this._initAgents();
    this._getAgentsTotals();

    // Routes Create/Change/Remove Event Listener
    this.routesRef.$subscribeToChannelEvents((updatedRoutes, action) => {

      const displayedAgentsIds = _.map(this.paginationData.content, 'id');
      const currentRouteIds = _.map(this.routes, 'id');

      const routesToAdd = [];
      const routesToUpdate = [];
      const routesToRemove = [];

      let taskIdsToAdd = [];
      let taskIdsToRemove = [];


      _.forEach(updatedRoutes, (updatedRoute) => {

        if (action === 'created' && _.includes(displayedAgentsIds, updatedRoute.agentId)) {
          routesToAdd.push(updatedRoute);
        }

        // Routes - Remove / Update
        if (action === 'changed' && _.includes(currentRouteIds, updatedRoute.id) && _.includes(displayedAgentsIds, updatedRoute.agentId)) {
          if (!!updatedRoute.isArchive) {
            routesToRemove.push(updatedRoute);
            taskIdsToAdd = _.concat(taskIdsToAdd, updatedRoute.taskIdListExt);
          } else {
            const currentRouteRef = _.find(this.routes, (route) => {
              return route.id === updatedRoute.id;
            })
            if (!!currentRouteRef) {
              routesToUpdate.push(updatedRoute);
              taskIdsToAdd = _.difference(updatedRoute.taskIdListExt, currentRouteRef.taskIdListExt);
              taskIdsToRemove = _.difference(currentRouteRef.taskIdListExt, updatedRoute.taskIdListExt);
            }
          }
        }
      })

      // Remove Routes
      if (routesToRemove.length) {
        const routeIdsToRemove = _.map(routesToRemove, 'id');
        this.routes = _.filter(this.routes, (r) => {
          return !_.includes(routeIdsToRemove, r.id)
        });
      }

      // Update Routes
      if (routesToUpdate.length) {
        this.routes = _.uniqBy(_.concat(routesToUpdate, this.routes), 'id');
      }

      // Add Routes
      if (routesToAdd.length) {
        const query = {
          ids: _.map(routesToAdd, 'id'),
          expandServices: false,
          expandTasks: false,
          expandTasksExt: false,
          expandAnalysis: false,
        }
        this.routesRef.$getAll(query)
          .then((ids) => {
            return this.routesRef.$asyncValues(ids)
          })
          .then((updatedRoutesToAdd) => {
            const updatedTasks = _.flatMap(updatedRoutesToAdd, 'routeTaskList')
            this.routes = _.uniqBy(_.concat(updatedRoutesToAdd, this.routes), 'id');
            this.tasksFacadeService.setMany(updatedTasks);
            // this.tasks = _.uniqBy(_.concat(updatedTasks, this.tasks), 'id');
          })
      }

      if (taskIdsToAdd.length) {
        // this.tasksRef.$getAll({ids: taskIdsToAdd})
        //   .then((ids) => {
        //     return this.tasksRef.$asyncValues(ids)
        //   })
        //   .then((tasksToUpdate) => {
        //     tasksToUpdate = _.filter(tasksToUpdate, (updatedTask) => {
        //       const currentTask = _.find(this.tasks, (task: TaskModel) => {
        //         return updatedTask.id === task.id;
        //       })
        //       return !currentTask || (updatedTask.updatedAt >= currentTask.updatedAt);
        //     })
        //     this.tasks = _.uniqBy(_.concat(tasksToUpdate, this.tasks), 'id');
        //   })
        this.tasksFacadeService.getByIds(taskIdsToAdd);
      }

      if (taskIdsToRemove.length) {
        // this.tasks = _.filter(this.tasks, (t) => {
        //   return !_.includes(taskIdsToRemove, t.id);
        // });
        this.tasksFacadeService.removeByIds(taskIdsToRemove);
      }

    });

    // Tasks Change Event Listener
    // this.tasksRef.$subscribeToChannelEvents((updatedTasks, action) => {
    //   if (action === 'changed' || action === 'partialChanged') {
    //     const updatedTasksIds = _.flatMap(updatedTasks, 'id');
    //     const tasksToUpdate = [];
    //
    //     _.forEach(updatedTasks, (t) => {
    //       var taskIndexToUpdate = _.findIndex(this.tasks, (t: any) => {
    //         return _.includes(updatedTasksIds, t.id);
    //       });
    //
    //       if (taskIndexToUpdate > -1) {
    //         if (!!_.get(t, 'routeAnalysis.agentId')) {
    //           tasksToUpdate.push(t);
    //         }
    //       }
    //
    //     })
    //
    //     if (tasksToUpdate.length) {
    //       this.tasks = _.uniqBy(_.concat(tasksToUpdate, this.tasks), 'id');
    //     }
    //
    //   }
    // });

    this.tasksFacadeService.subscribeToChannels();

    this.tasksSubscription = this.tasksFacadeService.selectAll()
      .subscribe((tasks: TaskModel[]) => {
        this.tasks = angular.copy(tasks);
        this.$timeout(0).then(() => {
        });
      })

    // Bind User Event Listeners
    this.commonsService.bindUserEvents((event) => {
      if (!!this.pushesTimeoutRef) {
        this._initPushesTimer();
      }
    })
    this._initPushesTimer();

  }

  $onChanges(changes) {
    if (changes.from && !changes.from.isFirstChange ||
      changes.to && !changes.to.isFirstChange) {
      this.filtersConfig.range = {dateStart: this.from, dateEnd: this.to};
    }
  };

  $onDestroy() {
    this.routesRef.$destroyChannel();
    // this.tasksRef.$destroyChannel();

    this.tasksFacadeService.removeAll();
    this.tasksSubscription.unsubscribe();
    this._destroyPushesTimer();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.filtersConfig.bringozFilters = filters;
    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);

    this._initAgents();
    this._getAgentsTotals();
    this._setStateParams();
  }

  onRangeChanged(range) {
    this.filtersConfig.range = range;
    this._setViewData();
    this._setStateParams();
  }

  getRangeDaysCount() {
    return this.moment(this.filtersConfig.range.dateEnd).diff(this.moment(this.filtersConfig.range.dateStart), 'days');
  }

  onDateFocus(selectedDate) {
    const range = angular.copy(this.filtersConfig.range);
    range.dateStart = this.moment(selectedDate).startOf('day').valueOf();
    range.dateEnd = this.moment(selectedDate).endOf('day').valueOf();
    this.onRangeChanged(range);
  }

  onExtraDaysBrowse(isNext) {
    const range = angular.copy(this.filtersConfig.range);
    const daysCount = this.getRangeDaysCount() + 1;

    if (!isNext) {
      range.dateStart = this.moment(range.dateStart).subtract(daysCount, 'day').startOf('day').valueOf();
      range.dateEnd = this.moment(range.dateEnd).subtract(daysCount, 'day').endOf('day').valueOf();
    } else {
      range.dateStart = this.moment(range.dateStart).add(daysCount, 'day').startOf('day').valueOf();
      range.dateEnd = this.moment(range.dateEnd).add(daysCount, 'day').endOf('day').valueOf();
    }

    this.onRangeChanged(range);
  }

  onSetExtraDays(extraDays) {
    const range = angular.copy(this.filtersConfig.range);
    range.dateEnd = this.moment(range.dateStart).add(extraDays, 'day').endOf('day').valueOf();

    this.onRangeChanged(range);
  }

  onRefreshRoutes() {
    this.analyticsService.trackEvent('Agents Shifts', 'Refresh Routes', 'Click');
    this._refreshRoutes();
  }

  onTabSelection(selectedTab) {
    this.selectedTab = selectedTab !== this.selectedTab ? selectedTab : undefined;
    this.onShiftUnSelect();
  }

  onPaginationBrowse(isNext) {
    this.page = isNext ? this.page + 1 : this.page - 1;

    this._setStateParams();
    this._initAgents();
  }

  onPaginationChange(page) {
    this.page = page - 1;

    this._setStateParams();
    this._initAgents();
  }

  onPageSizeChange(size) {
    this.size = size;
    this.page = 0;

    this._setStateParams();
    this._initAgents();
  }

  onQueryChange(queryString) {
    this.filtersConfig.queryString = queryString;
    this.page = 0;

    this._initAgents();
    this._getAgentsTotals();
  }

  onToggleIsTooltipsEnabled(isTooltipsEnabled) {
    this.isTooltipsEnabled = isTooltipsEnabled;
  }

  onToggleIsShowScheduleContentEnabled(isShowScheduleContentEnabled) {
    this.isShowScheduleContentEnabled = isShowScheduleContentEnabled;
  }

  onToggleIsShowUtilization(isShowUtilization) {
    this.isShowUtilization = isShowUtilization;
  }

  onToggleIsShowTaskColorByAgent(isShowTaskColorByAgent) {
    this.isShowTaskColorByAgent = isShowTaskColorByAgent;
  }

  saveAgentsSelect() {
    this.$mdSelect.hide();
  }

  onHighlightedItemsChange(highlightedSchedules, highlightedTasks, highlightedRoutes) {
    this.highlightedShifts = highlightedSchedules;
    this.highlightedTasks = highlightedTasks;
    this.highlightedRoutes = highlightedRoutes;
  }

  onUpdateShiftFromTimeline(shift, updateSpecificDay, callback) {
    this.confirmDialogService.confirm('Update Shift', 'Are you sure you want to update shift?')
      .then(() => {
        this.onUpdateShift(shift, updateSpecificDay);
      })
      .catch((error) => {
        callback(null);
      })
  }

  onTaskHighlight(task) {
    // this.highlightedTasks = [task];

    const highlightedTasksCopy = angular.copy(this.highlightedTasks);
    const currentIndex = this.highlightedTasks.findIndex((t) => {
      return t.id === task.id;
    })

    if (currentIndex > -1) {
      highlightedTasksCopy.splice(currentIndex, 1);
    } else {
      highlightedTasksCopy.push(task);
    }

    this.highlightedTasks = highlightedTasksCopy;
  }

  onAgentColorSelect(agent: AgentModel, color?: string) {
    this.commonsDialogService.selectColor(agent.displayColor || color)
      .then((selectedColor) => {
        const agentCopy = angular.copy(agent);
        agentCopy.displayColor = selectedColor;

        this._updateAgent(agentCopy);
      })
  }

  onToggleIsFavouriteAgentsMode() {
    this.isFavouriteAgentsMode = !this.isFavouriteAgentsMode;
    this.page = 0;
    this._initAgents();
    this._setStateParams();
  }

  onToggleFavouriteAgent(agentId: string) {
    let favouriteAgentIdsCopy = angular.copy(this.favouriteAgentIds);
    const currentIndex = favouriteAgentIdsCopy.findIndex((id: string) => {
      return id === agentId;
    })

    if (currentIndex >= 0) {
      favouriteAgentIdsCopy.splice(currentIndex, 1);
    } else {
      favouriteAgentIdsCopy.push(agentId);
    }

    const isSuccessful = this.agentsContextService.setFavouriteAgentIds(favouriteAgentIdsCopy);
    if (isSuccessful) {
      this.favouriteAgentIds = favouriteAgentIdsCopy;

      if (!!this.isFavouriteAgentsMode) {
        this.paginationData.content = _.filter(this.paginationData.content, (a) => {
          return !!_.includes(this.favouriteAgentIds, a.id)
        })

        if (!this.paginationData.content.length) {
          this.favouriteAgentIds = [];
          this.isFavouriteAgentsMode = false;
          this.page = 0;
          this._initAgents();
          this._setStateParams();
        }

      }
    }

  }

  onResetFavouriteAgents($event) {
    const title = 'Reset Favourites';
    const body = 'Are you sure you want to reset?';

    this.confirmDialogService.confirm(title, body, $event)
      .then(() => {
        this.agentsContextService.setFavouriteAgentIds([]);

        this.favouriteAgentIds = [];
        this.isFavouriteAgentsMode = false;
        this.page = 0;
        this._initAgents();
        this._setStateParams();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onToggleSort() {
    this.isSortMode = !this.isSortMode;
    this.page = 0;
    this._initAgents();
    this._setStateParams();
  }

  private _updateAgent(agent: AgentModel) {
    this.agentsService.updateOne(agent.id, agent)
      .then((updatedAgent) => {
        const agents = angular.copy(this.paginationData.content);
        const agentIndex = agents.findIndex((a) => {
          return a.id === agent.id;
        })

        if (agentIndex > -1) {
          agents.splice(agentIndex, 1, updatedAgent);
          this.paginationData.content = agents;
        }
      })
  }

  onShiftsBulkEditBreaks(highlightedShifts) {
    const highlightedShiftsCopy = angular.copy(highlightedShifts);

    this.scheduleDialogService.bulkEditBreaks(highlightedShiftsCopy)
      .then((extraDataItemsPayload) => {
        this._onUpdateExtraDataItems(extraDataItemsPayload, this.configZoneId);
      })
  }

  onShiftsBulkEditNotes(highlightedShifts) {
    const highlightedShiftsCopy = angular.copy(highlightedShifts);

    this.scheduleDialogService.bulkEditNotes(highlightedShiftsCopy)
      .then((extraDataItemsPayload) => {
        this._onUpdateExtraDataItems(extraDataItemsPayload, this.configZoneId);
      })
  }

  onToggleHighlightSchedule(id, shift, date, agent) {
    const shiftIndex = _.findIndex(this.highlightedShifts, (highlightedShiftData: any) => {
      return highlightedShiftData.id === id;
    })

    if (shiftIndex > -1) {
      const highlightedShiftsCopy = angular.copy(this.highlightedShifts);
      highlightedShiftsCopy.splice(shiftIndex, 1);
      this.highlightedShifts = highlightedShiftsCopy;
    } else {
      this.highlightedShifts = this.highlightedShifts.concat({
        id: id,
        schedule: shift,
        date: date,
        agent: agent
      })
    }

  }

  onCreateSchedule(agent, startDate?, endDate?) {
    const selectedShift = {
      agentSchedule: {
        schedule: {
          startTime: startDate,
          endTime: endDate
        }
      }
    }
    this.onShiftSelect(selectedShift, startDate, agent, true);
  }

  onShiftSelect(shift, date, agent?: AgentModel, isEdit?) {
    this.selectedShift = shift;
    this.selectedShiftDate = date;
    this.selectedShiftAgent = agent;
    this.isEditShiftEnabled = isEdit || false;
    this.selectedShiftTemplate = undefined;

    if (shift.scheduleExtraData?.length && shift.scheduleExtraData[0]?.routeId) {
      this.selectedRoute = this.routes.find(route => route.id === shift.scheduleExtraData[0].routeId);
    }

    const isRecurring = !!shift?.agentSchedule?.templateId && !shift?.agentSchedule?.template && !shift?.agentSchedule?.overridden;
    if (isRecurring) {
      this._getShiftTemplate(shift.agentSchedule.templateId, agent.id);
    }
  }

  onShiftUnSelect() {
    this.selectedRoute = undefined;
    this.selectedShift = undefined;
    this.selectedShiftTemplate = undefined;
    this.selectedShiftDate = undefined;
    this.selectedShiftAgent = undefined;
    this.isEditShiftEnabled = false;
  }

  onCreateShift(shift, weekDays) {

    if (!!weekDays) {
      const shifts = _.map(weekDays, (wd) => {
        const shiftCopy = angular.copy(shift);
        shiftCopy.agentSchedule.schedule.byWeekDay = [wd];
        return shiftCopy;
      })
      this._createMultipleSchedule(shifts);
    } else {
      this._createSchedule(shift);
    }
  }

  onUpdateShift(shift, updateSpecificDay) {
    const type = (!!updateSpecificDay || _.isUndefined(updateSpecificDay)) ? 'EVENT' : 'FUTURE';
    this._updateOneSchedule(shift, type, shift.agentSchedule.schedule.startTime);
  }

  onEditShift(enabled) {
    this.isEditShiftEnabled = enabled;
  }

  onAddNoteToShift($event, extraDataItem?) {
    this.scheduleDialogService.addNote($event, _.get(extraDataItem, 'internalNote'))
      .then((internalNote) => {
        const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
        const agentId = _.get(this.selectedShift, 'agentId');
        const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

        if (!extraDataItem) {
          extraDataItem = {};
        }

        const extraDataItemCopy = angular.copy(extraDataItem);
        extraDataItemCopy.internalNote = internalNote;
        const scheduleExtraDataPayload = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: this.selectedShiftDate,
          extraData: extraDataItemCopy
        }
        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  onRightClickBreak(schedule, breakId, event) {

    let actions = angular.copy(this.breakActions);

    if (this.highlightedShifts.length > 1) {
      _.forEach(actions, (a) => {
        a.name = a.nameMany
      })
    }

    const header = (this.highlightedShifts?.length > 1) ? `${this.highlightedShifts.length} shifts selected` : undefined;
    this.commonsService.openActionPanel(actions, event, header)
      .then((action: any) => {
        if (_.isEqual(action.key, 'EDIT')) {
          if (this.highlightedShifts.length > 1) {
            this._onBulkUpdateBreak(this.highlightedShifts, event);
          } else {
            this._onUpdateBreak(schedule, breakId, event);
          }
        }
        if (_.isEqual(action.key, 'EDIT_NOTES')) {
          this.onShiftsBulkEditNotes(this.highlightedShifts.length > 1 ? this.highlightedShifts : [schedule])
        }
        if (_.isEqual(action.key, 'DELETE')) {
          if (this.highlightedShifts.length > 1) {
            this._onDeleteBreaks(this.highlightedShifts, event);
          } else {
            this._onDeleteBreak(schedule, breakId, event);
          }
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onAddBreakToShift($event, extraDataItem?) {
    var day = this.moment(this.selectedShiftDate).date(),
      month = this.moment(this.selectedShiftDate).month(),
      year = this.moment(this.selectedShiftDate).year();

    const minStartTime = this.moment(this.selectedShift.agentSchedule.schedule.startTime).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    const minEndTime = this.moment(this.selectedShift.agentSchedule.schedule.endTime).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    const isRecurring = !!this.selectedShift?.agentSchedule?.templateId && !this.selectedShift.agentSchedule.template && !this.selectedShift.agentSchedule.overridden;
    this.scheduleDialogService.updateShiftBreak($event, undefined, isRecurring, minStartTime, minEndTime)
      .then((payload: {
        break: any,
        type: AgentScheduleExtraDataRequestType,
        repeatFrom?: string,
        repeatTo?: string
      }) => {
        const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
        const agentId = _.get(this.selectedShift, 'agentId');
        const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

        if (!extraDataItem) {
          extraDataItem = {};
        }

        const extraDataItemCopy = angular.copy(extraDataItem);

        if (!extraDataItemCopy.breaks?.length) {
          extraDataItemCopy.breaks = [];
        }

        extraDataItemCopy.breaks.push(payload.break);
        // extraDataItemCopy.breaks = [payload.break];

        const scheduleExtraDataPayload: AgentScheduleExtraDataRequestModel = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: this.selectedShiftDate,
          extraData: extraDataItemCopy,
          type: payload.type,
        }

        if (payload.repeatFrom && payload.repeatTo) {
          scheduleExtraDataPayload.repeatFrom = payload.repeatFrom;
          scheduleExtraDataPayload.repeatTo = payload.repeatTo;
        }

        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  onEditBreakToShift($event, extraDataItem, breakIndex) {
    var day = this.moment(this.selectedShiftDate).date(),
      month = this.moment(this.selectedShiftDate).month(),
      year = this.moment(this.selectedShiftDate).year();

    const minStartTime = this.moment(this.selectedShift.agentSchedule.schedule.startTime).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    const minEndTime = this.moment(this.selectedShift.agentSchedule.schedule.endTime).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    const isRecurring = !!this.selectedShift?.agentSchedule?.templateId && !this.selectedShift.agentSchedule.template && !this.selectedShift.agentSchedule.overridden;
    this.scheduleDialogService.updateShiftBreak($event, extraDataItem.breaks[breakIndex], isRecurring, minStartTime, minEndTime)
      .then((payload: {
        break: any,
        type: AgentScheduleExtraDataRequestType,
        repeatFrom?: string,
        repeatTo?: string
      }) => {
        const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
        const agentId = _.get(this.selectedShift, 'agentId');
        const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');


        const extraDataItemCopy = angular.copy(extraDataItem);

        extraDataItemCopy.breaks[breakIndex] = payload.break;

        const scheduleExtraDataPayload: AgentScheduleExtraDataRequestModel = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: this.selectedShiftDate,
          extraData: extraDataItemCopy,
          type: payload.type,
        }

        if (payload.repeatFrom && payload.repeatTo) {
          scheduleExtraDataPayload.repeatFrom = payload.repeatFrom;
          scheduleExtraDataPayload.repeatTo = payload.repeatTo;
        }

        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  onRemoveNoteFromShift($event, extraDataItem?) {
    const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
    const agentId = _.get(this.selectedShift, 'agentId');
    const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

    const extraDataItemCopy = angular.copy(extraDataItem);
    extraDataItemCopy.internalNote = undefined;
    const scheduleExtraDataPayload = {
      scheduleId: scheduleId,
      agentId: agentId,
      eventDate: this.selectedShiftDate,
      extraData: extraDataItemCopy
    }
    this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
  }

  onRemoveBreakFromShift($event, extraDataItem, breakIndex) {
    let extraDataItemCopy = angular.copy(extraDataItem);
    // if (!extraDataItemCopy) {
    //   extraDataItemCopy = {};
    // } else {
    //   _.unset(extraDataItemCopy, 'breaks');
    // }

    extraDataItemCopy.breaks.splice(breakIndex, 1);

    const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
    const agentId = _.get(this.selectedShift, 'agentId');
    const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

    const scheduleExtraDataPayload = {
      scheduleId: scheduleId,
      agentId: agentId,
      eventDate: this.selectedShiftDate,
      extraData: extraDataItemCopy
    }
    this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
  }

  onMoveGroup(agentId, index) {
    if (this.isFavouriteAgentsMode) {
      let favouriteAgentIdsCopy = angular.copy(this.favouriteAgentIds);
      favouriteAgentIdsCopy = favouriteAgentIdsCopy.filter((id) => {
        return id !== agentId;
      })
      favouriteAgentIdsCopy.splice(index, 0, agentId);
      this.favouriteAgentIds = favouriteAgentIdsCopy;
      this.agentsContextService.setFavouriteAgentIds(favouriteAgentIdsCopy);
    }
  }

  onMoveTask(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, scheduleInstanceId, originalId, agentId, isBetweenDays, toDate, item, assignServices, resetServices, callback) {
    var functionRef = isBetweenDays ? this.deliveriesDialogService.editServiceTimeWindow(serviceIds[0], toDate) : this.$q.when();
    functionRef
      .then((payload) => {
        const dateEdit = {
          type: 'ChangeNotBeforeNotAfter',
          notBefore: _.get(payload, 'service.notBefore'),
          notAfter: _.get(payload, 'service.notAfter')
        }
        this.loading = true;
        return !!_.get(payload, 'service') ? this.servicesService.updateBulk(serviceIds, {dateEdit}, payload.isShouldSendSms) : this.$q.when();
      })
      .then(() => {
        this._editRoutes(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, scheduleInstanceId, originalId, agentId, assignServices, resetServices, callback)
      })
      .catch((error) => {
        this.loading = false;
        callback(null);
      })
  }

  addServicesToRoute(routeId, serviceIds) {
    if (!this.validateRouteAssignment) {
      this._addServicesToRouteSyncTimeWindow(routeId, serviceIds);
    } else {
      this.leanPlanningService.validateAssignment(routeId, serviceIds)
        .then((res: {isValid: boolean, reason: RouteEditValidationResultEnum}) => {
          if (res.isValid) {
            this._addServicesToRouteSyncTimeWindow(routeId, serviceIds);
          } else {
            this.leanPlanningAlertsService.validateAssignmentError(res.reason);
          }
        })
    }
  }

  addServicesToNewRoute(allocationInstanceId, allocationTimeWindowId, serviceIdList, notBefore, notAfter) {
    const payload = {
      planningResource: {
        allocationInstanceId: allocationInstanceId,
        allocationTimeWindowId: allocationTimeWindowId,
        supplyResourceSource: "AgentSchedule"
      },
      serviceIdList: serviceIdList,
      notBefore: notBefore,
      notAfter: notAfter
    }

    this.leanPlanningService.createRouteFromServicesSyncTimeWindow(payload)
      .then((res) => {
        this.onShiftUnSelect();
        this._refreshSchedules();
      })
  }

  // onMoveTask(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, scheduleInstanceId, agentId, isBetweenDays, toDate, item, assignServices, resetServices, callback) {
  //   var serviceIdToMove;
  //   var isBundle = _.get(serviceIds, 'length') > 1;
  //   var functionRef = isBundle ? this.deliveriesDialogService.selectService(serviceIds) : this.$q.when(serviceIds[0]);
  //   functionRef
  //     .then((service) => {
  //       serviceIdToMove = _.get(service, 'id') || serviceIds[0];
  //       if (!!_.get(service, 'id') && isBundle) {
  //
  //         toOrderedIds = _.filter(toOrderedIds, (taskId) => {
  //           return !_.includes(_.get(item, 'taskIdList'), taskId) || _.includes(service.taskIdList, taskId);
  //         })
  //       }
  //       return isBetweenDays ? this.deliveriesDialogService.editServiceTimeWindow(serviceIdToMove, toDate) : this.$q.when();
  //     })
  //     .then((payload) => {
  //       return !! _.get(payload, 'service') ? this.deliveriesService.updateService(payload.service, payload.isShouldSendSms) : this.$q.when();
  //     })
  //     .then(() => {
  //       this._editRoutes([serviceIdToMove], fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, scheduleInstanceId, agentId,  assignServices, resetServices, callback)
  //     })
  //     .catch((error) => {
  //       callback(null);
  //     })
  // }

  onViewServices(serviceIds) {
    this.bringozLoaderService.on();
    this.servicesRef.$getAll({ids: serviceIds})
      .then((ids: string[]) => {
        return this.servicesRef.$asyncValues(ids)
      })
      .then((services) => {
        if (services.length > 1) {
          this.deliveriesDialogService.servicesInfo(services);
        } else {
          this.deliveriesDialogService.serviceInfo(services[0]);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onRightClickTask(task, agentId, $event) {
    let actions = angular.copy(this.taskActions);

    const routeRef = _.find(this.routes, (r) => {
      return r.id === task.routeId;
    })
    const canReoptimize = this.leanPlanningService.getRoutesActionsMap([routeRef]).reOptimize


    if (!canReoptimize) {
      actions = actions.filter(a => {
        return a.key !== 'REOPTIMIZE_ROUTE';
      })
    }

    this.commonsService.openActionPanel(actions, $event)
      .then((action: any) => {
        if (_.isEqual(action.key, 'ASSIGN_ROUTE')) {
          this._assignAgent(task.routeId, agentId, true);
        }
        if (_.isEqual(action.key, 'REOPTIMIZE_ROUTE')) {
          this._onReoptimizeRoute(task.routeId);
        }
        if (_.isEqual(action.key, 'RESET_ROUTE')) {
          this._onResetRoute(task.routeId);
        }
        if (_.isEqual(action.key, 'DELETE_ROUTE')) {
          this._deleteRoute(task.routeId);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onRightClickShift(shift, $event) {
    let actions = angular.copy(this.shiftActions);

    if (this.highlightedShifts.length > 1) {
      actions = actions.filter(a => {
        return a.key !== 'EDIT' && a.key !== 'DELETE';
      })
      _.forEach(actions, (a) => {
        a.name = a.nameMany
      })
    }

    const header = (this.highlightedShifts?.length > 1) ? `${this.highlightedShifts.length} shifts selected` : undefined;
    this.commonsService.openActionPanel(actions, $event, header)
      .then((action: any) => {
        const selectedShift = angular.copy(shift);
        const selectedShiftDate = this.moment(shift.agentSchedule.schedule.startTime).valueOf();

        if (_.isEqual(action.key, 'EDIT')) {
          const agentRef: any = _.find(this.paginationData?.content, (a) => {
            return a.id === selectedShift.agentId;
          })
          this.onShiftSelect(selectedShift, selectedShiftDate, agentRef, true);
        }

        if (_.isEqual(action.key, 'EDIT_BREAK')) {

          if (this.highlightedShifts.length > 1) {
            this._onBulkUpdateBreak(this.highlightedShifts, $event);
          } else {
            // Shift level action, no specific break was clicked - fallback to the shift first break.
            this._onUpdateBreak(selectedShift, undefined, $event);
          }
        }

        if (_.isEqual(action.key, 'EDIT_BREAKS')) {
          this._onBulkUpdateBreak(this.highlightedShifts.length > 1 ? this.highlightedShifts : [selectedShift], $event);
        }

        if (_.isEqual(action.key, 'EDIT_NOTES')) {
          this.onShiftsBulkEditNotes(this.highlightedShifts.length > 1 ? this.highlightedShifts : [selectedShift])
          // this.onShiftsBulkEditNotes(this.highlightedShifts.length ? (this.highlightedShifts) : [selectedShift]);
        }

        if (_.isEqual(action.key, 'DELETE')) {
          this._onDeleteSchedule(selectedShift, $event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onTaskChange(id, routeId,  serviceTime?, detailedServiceTime?) {
    // var serviceTime = this.moment(notAfter).diff(this.moment(notBefore));

    const payload = {
      detailedServiceTime: detailedServiceTime,
      legacyServiceTime: serviceTime,
      useLegacyServiceTime: !!serviceTime
    }

    this.loading = true;
    this.routesService.updateTaskTimeWindow(routeId, id, payload)
      .then((updatedRoute: any) => {
        let routesCopy = angular.copy(this.routes);
        routesCopy = _.filter(routesCopy, (r) => {
          return r.id !== updatedRoute.id;
        })
        this.routes = _.uniqBy([updatedRoute].concat(routesCopy), 'id');
        this.leanPlanningAlertsService.updateTaskSuccess();
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onSelectedServicesChange(selectedServices) {
    this.selectedServices = selectedServices;
  }

  onViewSettingsChange(settings) {
    // this.viewSettings.settings = settings;

    if (this.viewSettings?.id) {
      const viewTableSettingsCopy = {...this.viewSettings, settings: settings};
      viewTableSettingsCopy.holderType = ViewSettingsHolderType.User;

      this.viewSettingsService.updateByUser(this.viewSettings.id, viewTableSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.viewSettings = viewSettingsTable
        })

    } else {
      const viewTableSettings = {
        pageName: 'agents-schedule-new',
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.ViewTable,
        settings: settings
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.viewSettings = viewSettingsTable
        })
    }
  }

  // ******************************
  //        Private methods
  // ******************************

  private _setStateParams() {
    this.$state.go('.', {
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      agentsGroup: this.filtersConfig.bringozFilters.agentStatus,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      isFavouriteAgentsMode: this.isFavouriteAgentsMode,
      isSortMode: this.isSortMode,
      serviceAreaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      agentType: this.filtersConfig.bringozFilters.agentType,
      agentSkills: this.filtersConfig.bringozFilters.agentSkills,
      agentAssistant: this.filtersConfig.bringozFilters.agentAssistant,
      size: this.size,
      selectedQuickFilterId: this.selectedQuickFilterId,
    }, {notify: false, reload: false});
  }

  private _initAgents() {
    const agentsGroupRef = this.filtersConfig.bringozFilters.agentStatus;

    // this.paginationData = undefined;
    this.agentsService.getAgentsPagination(this._getAgentsQuery())
      .then((paginationData: AgentsPaginationDataModel) => {
        this.paginationData = paginationData;

        let pages = [];
        _.times(paginationData.totalPages, (i) => {
          pages.push(i);
        });

        this.paginationPages = pages;

        // Sort by favouriteAgentIds list.
        if (!this.isSortMode && !!this.isFavouriteAgentsMode) {
          const agentsMap = _.mapKeys(paginationData.content, (agent) => {
            return agent.id;
          });
          this.paginationData.content = _.map(this.favouriteAgentIds, (id) => {
            return agentsMap[id];
          })
        }

        this._setViewData();
      })
  }

  private _getAgentsTotals() {
    this.totals = undefined;
    this.agentRequests.getAgentTotals(this._getAgentsTotalsQuery())
      .then((totals) => {
        this.totals = {
          onDuty: totals.onDuty + totals.onDutyOnBreak,
          offDuty: totals.offDuty,
          total: totals.total
        };
      })
      .catch((error) => {
        this.$log.error('Failed to get totals, teamDrivers@reloadTotals', error);
      })
  }

  private _createSchedule(schedule) {
    if (schedule && !this.isLoadingCreateShift) {

      this.isLoadingCreateShift = true;

      const agentSchedule = angular.copy(schedule.agentSchedule);
      agentSchedule.schedule.zoneIdName = this.splitService.getTimeZone();

      if (!agentSchedule.schedule.interval) {
        agentSchedule.schedule.interval = 1;
      }

      this.scheduleService.createManyByAgentIdIgnoringConflicts([agentSchedule], this.selectedShiftAgent.id)
        .then((createdSchedule) => {
          this.onShiftUnSelect();
          this._refreshSchedules();
        })
        .finally(() => {
          this.isLoadingCreateShift = false;
        })
    }
  }

  private _createMultipleSchedule(shifts) {
    if (shifts.length) {

      const agentSchedulesList = [];

      _.forEach(shifts, (s) => {
        const agentSchedule = angular.copy(s.agentSchedule);
        agentSchedule.schedule.zoneIdName = this.splitService.getTimeZone();
        agentSchedule.schedule.interval = 1;
        agentSchedulesList.push(agentSchedule);
      })

      this.scheduleService.createManyByAgentIdIgnoringConflicts(agentSchedulesList, this.selectedShiftAgent.id)
        .then((createdSchedule) => {
          this.onShiftUnSelect();
          this._refreshSchedules();
        });
    }
  }

  private _updateOneSchedule(shift, type, eventInstanceDate) {
    this.scheduleService.updateOneByAgentId(shift.agentSchedule, shift.agentSchedule.id, shift.agentId, type, eventInstanceDate)
      .then((updatedSchedule) => {
        // const shiftRef = _.find(this.schedules, (s) => {
        //   return s.id === this.selectedShift.id;
        // })
        //
        // shiftRef.agentSchedule = updatedSchedule;
        // this.schedules = angular.copy(this.schedules);
        // this.selectedShift.agentSchedule = updatedSchedule;
        // this.isEditShiftEnabled = false;
        this.onShiftUnSelect();
        this._refreshSchedules();
      });
  }

  private _onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId) {
    this.scheduleService.updateScheduleExtraData([scheduleExtraDataPayload], zoneId)
      .then((updatedExtraDataItems) => {

        if (this.selectedShift) {
          const shiftRef = _.find(this.schedules, (s) => {
            return s.id === this.selectedShift.id;
          })

          if (!shiftRef.scheduleExtraData) {
            shiftRef.scheduleExtraData = [];
          }

          shiftRef.scheduleExtraData = _.uniqBy(_.concat(updatedExtraDataItems, shiftRef.scheduleExtraData), 'id');
          shiftRef.agentSchedule.updatedAt = this.moment().valueOf();
          this.selectedShift = angular.copy(shiftRef);
        }

        this.isEditShiftEnabled = false;
        this.$timeout(1000).then(() => {
          this._refreshSchedules();
        })
      })
  }

  private _onUpdateExtraDataItems(scheduleExtraDataPayload, zoneId) {
    this.scheduleService.updateScheduleExtraData(scheduleExtraDataPayload, zoneId)
      .then((updatedExtraDataItems) => {
        this.highlightedShifts = [];
        this._refreshSchedules();
      })
  }

  // private _onUpdateNote(note, scheduleId, agentId, instanceDate, zoneId) {
  //   this.scheduleService.updateScheduleExtraData(note, scheduleId, agentId, instanceDate, zoneId)
  //     .then((updatedExtraDataObject) => {
  //       const shiftRef = _.find(this.schedules, (s) => {
  //         return s.id === this.selectedShift.id;
  //       })
  //
  //       if (!shiftRef.scheduleExtraData) {
  //         shiftRef.scheduleExtraData = [];
  //       }
  //
  //       shiftRef.scheduleExtraData = _.uniqBy(_.concat([updatedExtraDataObject], shiftRef.scheduleExtraData), 'id');
  //       shiftRef.agentSchedule.updatedAt = this.moment().valueOf();
  //       this.schedules = angular.copy(this.schedules);
  //
  //       this.selectedShift = angular.copy(shiftRef);
  //       this.isEditShiftEnabled = false;
  //     })
  // }

  private _setViewData() {

    this.schedules = [];
    this.routes = [];
    // this.tasks = [];
    this.tasksFacadeService.removeAll();
    this.serviceAreas = [];

    const displayedAgentsIds = _.map(this.paginationData.content, 'id');

    if (displayedAgentsIds && displayedAgentsIds.length) {

      const schedules = this._getSchedules(displayedAgentsIds, this.filtersConfig.range.dateStart, this.filtersConfig.range.dateEnd, this.filtersConfig.bringozFilters.serviceAreaIds),
        routes = this._getRoutes(this.filtersConfig.range.dateStart, this.filtersConfig.range.dateEnd, displayedAgentsIds, this.filtersConfig.bringozFilters.branchIds, this.filtersConfig.bringozFilters.serviceAreaIds),
        serviceAreas = this._getServiceAreasByAgents(this.paginationData.content)

      this.$q.all([schedules, routes, serviceAreas])
        .then((response: any) => {
          this._setSchedules(response[0]);
          this.routes = response[1];
          // this.tasks = _.flatMap(response[1], 'routeTaskList');
          this.tasksFacadeService.setMany(_.flatMap(response[1], 'routeTaskList'));
          this.serviceAreas = response[2];
        })
    }
  }

  private _getAgentsQuery() {
    const group = this.filtersConfig.bringozFilters.agentStatus;
    const size = !!this.isFavouriteAgentsMode ?
      this.favouriteAgentIds.length :
      this.size;

    const queryPayload: AgentsPaginationQueryModel = {
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentTypes: this.filtersConfig.bringozFilters.agentType,
      // depotIds?: string[];
      // accountIds?: string[];
      group: undefined,
      status: this.filtersConfig.bringozFilters.agentStatus,
      // type?: EmploymentType;
      activeAssistant: this.filtersConfig.bringozFilters.agentAssistant,
      // noArea?: boolean;
      areaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      skill: this.filtersConfig.bringozFilters.agentSkills,
      query: this.filtersConfig.queryString,
      ids: this.isFavouriteAgentsMode ? this.favouriteAgentIds :
        (this.filtersConfig.bringozFilters.agentIds.length ? this.filtersConfig.bringozFilters.agentIds : undefined),
      // vehicleId?: string[];
      active: true,
      // registrationStatusActive?: boolean; // default true
      page: this.page, // default 0
      size: size, // default 20
      sort: this.isSortMode ? ['fullName,asc'] : ['fullName,desc'],
      // sort: ['fullName,asc']
      // sort?: string[] // default numberOfTasks,desc


      // agentTypes: this.filtersConfig.bringozFilters.agentType ?
      //   [this.filtersConfig.bringozFilters.agentType] : undefined
    };

    if (!!group) {
      if (_.isEqual(group, 'Active')) {
        queryPayload.group = group;
        // queryPayload.status = 'OnDuty';
      }
      if (_.isEqual(group, 'OffDuty')) {
        queryPayload.status = group;
      }
    }

    return queryPayload;
  }

  private _getAgentsTotalsQuery() {
    return {
      query: this.filtersConfig.queryString,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      ids: this.isFavouriteAgentsMode ? this.favouriteAgentIds :
        (this.filtersConfig.bringozFilters.agentIds.length ? this.filtersConfig.bringozFilters.agentIds : undefined),
      areaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      activeAssistant: this.filtersConfig.bringozFilters.agentAssistant,
      skill: this.filtersConfig.bringozFilters.agentSkills,
      agentTypes: this.filtersConfig.bringozFilters.agentType ?
        [this.filtersConfig.bringozFilters.agentType] : undefined
    }
  }

  private _refreshRoutes() {
    const displayedAgentsIds = _.map(this.paginationData.content, 'id');

    this.loadingRoutes = true;
    this._getRoutes(
      this.filtersConfig.range.dateStart,
      this.filtersConfig.range.dateEnd,
      displayedAgentsIds,
      this.filtersConfig.bringozFilters.branchIds,
      this.filtersConfig.bringozFilters.serviceAreaIds)
      .then((routes) => {
        this.routes = routes;
      })
      .finally(() => {
        this.loadingRoutes = false;
      })
  }

  private _refreshSchedules() {
    const displayedAgentsIds = _.map(this.paginationData.content, 'id');
    this._getSchedules(displayedAgentsIds, this.filtersConfig.range.dateStart, this.filtersConfig.range.dateEnd, this.filtersConfig.bringozFilters.serviceAreaIds)
      .then((schedules) => {
        this._setSchedules(schedules);
      });
  }

  private _getSchedules(displayedAgentsIds, from, to, serviceAreaIds) {
    return this.scheduleService.getByAgentIds(displayedAgentsIds, from, to, undefined, serviceAreaIds, true);
  }

  private _getRoutes(from, to, agentIds, branchIds, serviceAreaIds) {
    var query: RoutesListPayloadModel = {
      from: from,
      to: to,
      expandServices: false,
      expandTasks: false,
      expandTasksExt: false,
      expandAnalysis: false,
      branchIds: branchIds,
      areaIds: serviceAreaIds,
      agentIds: agentIds,
      supplyResourceSource: 'AgentSchedule',
      statusGroup: 'Active'
    }

    return this.routesService.getRoutesList(query);

    // this.bringozLoaderService.on();
    // return this.routesRef.$getAll(query)
    //   .then((ids) => {
    //     return this.routesRef.$asyncValues(ids);
    //   })
    //   .catch((error) => {
    //     this.$log.error('Failed to get allocations', error)
    //   })
    //   .finally(() => {
    //     this.bringozLoaderService.off();
    //   })
  }

  private _getRoutesByIds(routeIds) {
    var query = {
      ids: routeIds,
      expandServices: false,
      expandTasks: false,
      expandTasksExt: false,
      expandAnalysis: false
    }
    this.bringozLoaderService.on();
    return this.routesRef.$getAll(query)
      .then((ids) => {
        return this.routesRef.$asyncValues(ids);
      })
      .catch((error) => {
        this.$log.error('Failed to get allocations', error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private _getServiceAreasByAgents(agents) {
    const priorityServiceAreasIds = _.chain(agents)
      .flatMap('agentPreferencesReference.priorityServiceAreas')
      .compact()
      .uniq()
      .value()

    return priorityServiceAreasIds.length ? this.serviceAreasService.getAreasByIds(priorityServiceAreasIds) : this.$q.when([]);
  }

  private _setSchedules(schedules) {
    this.schedules = schedules;
  }

  _editRoutes(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, scheduleInstanceId, originalId, agentId, assignServices, resetServices, callback) {
    if (!fromRouteId && !toRouteId) {
      this._createNewRoute(scheduleInstanceId, originalId, serviceIds)
      return;
    } else if (!fromRouteId && !!toRouteId) {
      const routeRef = _.find(this.routes, (r) => {
        return r.id === toRouteId
      });
      const assignAddedDeliveries = routeRef?.status === ServiceStatus.Assigned || routeRef?.status === ServiceStatus.Started;
      this.leanPlanningService.addServicesToRoute(serviceIds, toRouteId, assignAddedDeliveries)
    } else {
      var payload = this.TimelineService.getMovedTaskPayload(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);
      this.loading = true;
      this.leanPlanningService.editRoutes(payload, assignServices, resetServices)
        .then((updatedRoutes) => {
          if (!toRouteId) {
            var branchIds;
            var routeRef = _.find(this.routes, (r) => {
              return r.agentId === agentId
            })
            if (routeRef) {
              branchIds = routeRef.branchIds;
            }
            this._createNewRoute(scheduleInstanceId, originalId, serviceIds, branchIds)
          } else {
            this._refreshSchedules();
          }
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }

  _createNewRoute(scheduleInstanceId, originalId, serviceIds, branchIds?) {
    const createRoutePayload = {
      branchIds: branchIds,
      planningResource: {
        allocationInstanceId: scheduleInstanceId,
        allocationTimeWindowId: originalId,
        supplyResourceSource: "AgentSchedule"
      },
      serviceIdList: serviceIds
    }
    this.loading = true;
    this.leanPlanningService.createRoute(createRoutePayload)
      .then((createdRoute) => {
        this.routes = _.uniqBy(_.concat([createdRoute], this.routes), 'id');
        // TODO: tasks missing routeAnalysis?
        // const currentRouteIds = _.map(this.routes, 'id');
        // if (!_.includes(currentRouteIds, createdRoute.id)) {
        //   this.routes = _.concat(this.routes, [createdRoute]);
        // }
        this._refreshSchedules();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to change route itinerary @planningRoute@onRouteOrderChange', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  _assignAgent(routeId, agentId, assignServices) {
    this.loading = true;
    this.leanPlanningService.assignRouteToAgent(routeId, agentId, assignServices)
      .then((assignedRoute) => {
        const updatedRouteIndex = _.findIndex(this.routes, (r: any) => {
          return r.id === routeId
        })
        if (updatedRouteIndex > -1) {
          const routesCopy = angular.copy(this.routes);
          routesCopy[updatedRouteIndex].status = 'Assigned';
          routesCopy[updatedRouteIndex].updatedTime = this.moment().valueOf();
          this.routes = routesCopy;
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  _onReoptimizeRoute(routeId) {
    this.confirmDialogService.confirm('Reoptimize Route', 'Are you sure you want to reoptimize route?')
      .then(() => {
        this._reoptimizeRoute(routeId);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  _onResetRoute(routeId) {
    this.confirmDialogService.confirm('Reset Route', 'Are you sure you want to reset?')
      .then(() => {
        this._resetRoute(routeId);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  _reoptimizeRoute(routeId) {
    this.loading = true;
    this.leanPlanningService.optimizeRoute(routeId)
      .then((updatedRoute) => {
        // ctrl.routes = _.uniqBy([updatedRoute].concat(ctrl.routes), 'id');
      })
      .finally(() => {
        this.loading = false;
      })
  }

  _resetRoute(routeId) {
    this.loading = true;
    this.routesService.resetRoutes([routeId])
      .then((updatedRoute) => {
        // ctrl.routes = _.uniqBy([updatedRoute].concat(ctrl.routes), 'id');
      })
      .finally(() => {
        this.loading = false;
      })
  }

  _deleteRoute(routeId) {
    this.loading = true;
    this.routesService.deleteRoutes([routeId])
      .then((res) => {
        this.routes = _.filter(this.routes, (r) => {
          return r.id !== routeId;
        });

        // this.tasks = _.filter(this.tasks, (t) => {
        //   return t.routeId !== routeId;
        // })

        const taskIdsToRemove = _.filter(this.tasks, (t: TaskModel) => {
          return t.routeId === routeId;
        }).map(task => task.id);

        this.tasksFacadeService.removeByIds(taskIdsToRemove);

        this._refreshSchedules();
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _onDeleteSchedule(shiftItem, $event) {
    var eventInstanceDate;
    var changeType;
    const isRecurring = !!shiftItem.agentSchedule.templateId && !shiftItem.agentSchedule.overridden;

    var functionRef = !!isRecurring ?
      this.scheduleDialogService.selectChangeType($event, 'SCHEDULE_DELETE_INFO') :
      this.confirmDialogService.confirm('Delete shift', 'SCHEDULE_DELETE_INFO');

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        changeType = selectedChangeType || 'EVENT';

        if (changeType === 'EVENT' || changeType === 'FUTURE') {
          eventInstanceDate = shiftItem.agentSchedule.schedule.startTime;
        }

        this._deleteSchedule(shiftItem.agentSchedule.id, shiftItem.agentId, changeType, eventInstanceDate);
        // _updateOneSchedule(editedSchedule, changeType, eventInstanceDate);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      });
  }

  private _deleteSchedule(scheduleId, agentId, type, eventInstanceDate) {
    this.scheduleService.deleteOneByAgentId(scheduleId, agentId, type, eventInstanceDate)
      .then((deletedShift) => {
        this._refreshSchedules();
      })
  }

  private _getShiftTemplate(templateId: string, agentId: string) {
    this.scheduleService.getOneByAgentId(templateId, agentId)
      .then((template) => {
        if (!!this.selectedShift) {
          this.selectedShiftTemplate = template;
        }
      })
  }

  private _onUpdateBreak(schedule, breakId, event) {
    const scheduleExtraDataRef = _.get(schedule, 'scheduleExtraData[0]');
    const breaksRef = _.get(scheduleExtraDataRef, 'breaks');
    const selectedBreakRef = breakId ? _.find(breaksRef, {id: breakId}) : _.first(breaksRef);

    if (breakId && !selectedBreakRef) {
      this.$log.warn('Break to update was not found on the shift extra data', breakId);
      return;
    }

    const isRecurring = !!schedule.agentSchedule.templateId && !schedule.agentSchedule.template && !schedule.agentSchedule.overridden;
    this.scheduleDialogService.updateShiftBreak(event, selectedBreakRef, isRecurring, schedule.agentSchedule.schedule.startTime, schedule.agentSchedule.schedule.endTime)
      .then((payload: {
        break: any,
        type: AgentScheduleExtraDataRequestType,
        repeatFrom?: string,
        repeatTo?: string
      }) => {
        const scheduleId = _.get(schedule, 'agentSchedule.id');
        const agentId = _.get(schedule, 'agentId');
        const zoneId = _.get(schedule, 'agentSchedule.schedule.timezone');
        const extraDataItem = scheduleExtraDataRef || {};

        const extraDataItemCopy = angular.copy(extraDataItem);

        if (!extraDataItemCopy.breaks?.length) {
          extraDataItemCopy.breaks = [];
        }

        // Replace only the break that was clicked, the other shift breaks must stay untouched.
        if (selectedBreakRef?.id) {
          extraDataItemCopy.breaks = _.map(extraDataItemCopy.breaks, (breakRef: any) => {
            return breakRef.id === selectedBreakRef.id ? payload.break : breakRef;
          });
        } else if (selectedBreakRef) {
          extraDataItemCopy.breaks[0] = payload.break;
        } else {
          extraDataItemCopy.breaks.push(payload.break);
        }

        const scheduleExtraDataPayload: AgentScheduleExtraDataRequestModel = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: schedule.agentSchedule.schedule.startTime,
          extraData: extraDataItemCopy,
          type: payload.type
        }

        if (payload.repeatFrom && payload.repeatTo) {
          scheduleExtraDataPayload.repeatFrom = payload.repeatFrom;
          scheduleExtraDataPayload.repeatTo = payload.repeatTo;
        }

        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  private _onDeleteBreak(schedule, breakId, event) {
    const scheduleExtraDataRef = _.get(schedule, 'scheduleExtraData[0]');
    const breaksRef = _.get(scheduleExtraDataRef, 'breaks');
    const selectedBreakRef = breakId ? _.find(breaksRef, {id: breakId}) : _.first(breaksRef);

    if (!selectedBreakRef) {
      this.$log.warn('Break to delete was not found on the shift extra data', breakId);
      return;
    }

    const isRecurring = !!schedule.agentSchedule.templateId && !schedule.agentSchedule.template && !schedule.agentSchedule.overridden;
    this.scheduleDialogService.deleteShiftBreak(event, selectedBreakRef, isRecurring)
      .then((payload: { type: AgentScheduleExtraDataRequestType }) => {
        const scheduleId = _.get(schedule, 'agentSchedule.id');
        const agentId = _.get(schedule, 'agentId');
        const zoneId = _.get(schedule, 'agentSchedule.schedule.timezone');
        const extraDataItem = scheduleExtraDataRef || {};

        const extraDataItemCopy = angular.copy(extraDataItem);
        // Remove only the break that was clicked, the other shift breaks must stay untouched.
        if (selectedBreakRef.id) {
          extraDataItemCopy.breaks = _.filter(extraDataItemCopy.breaks, (breakRef: any) => {
            return breakRef.id !== selectedBreakRef.id;
          });
        } else {
          extraDataItemCopy.breaks.shift();
        }

        const scheduleExtraDataPayload: AgentScheduleExtraDataRequestModel = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: schedule.agentSchedule.schedule.startTime,
          extraData: extraDataItemCopy,
          type: payload.type
        }
        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  private _onDeleteBreaks(schedules, event) {
    this.confirmDialogService.confirm('Delete Breaks', 'Are you sure you want to delete breaks?')
      .then(() => {
        const extraDataItemsPayload = [];
        _.forEach(schedules, (s) => {
          const scheduleId = _.get(s, 'agentSchedule.id');
          const agentId = _.get(s, 'agentId');
          const zoneId = _.get(s, 'agentSchedule.schedule.timezone'); // ?? currently ignored and all by configZoneId
          const extraDataItem = _.get(s, 'scheduleExtraData[0]', {});

          const extraDataItemCopy = angular.copy(extraDataItem);
          extraDataItemCopy['breaks'] = [];

          const scheduleExtraDataPayload: AgentScheduleExtraDataRequestModel = {
            scheduleId: scheduleId,
            agentId: agentId,
            eventDate: s.agentSchedule.schedule.startTime,
            extraData: extraDataItemCopy,
            type: AgentScheduleExtraDataRequestType.INDIVIDUAL
          }
          extraDataItemsPayload.push(scheduleExtraDataPayload)
        })

        this._onUpdateExtraDataItems(extraDataItemsPayload, this.configZoneId);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  private _addServicesToRouteSyncTimeWindow(routeId, serviceIds) {
    const payload = [
      {
        id: routeId,
        add: serviceIds
      }
    ];
    this.leanPlanningService.addServicesToRouteSyncTimeWindow(payload)
      .then((res) => {
        this.onShiftUnSelect();
        this._refreshSchedules();
      })
  }

  private _onBulkUpdateBreak(schedules, event) {

    const highlightedShiftsCopy = angular.copy(schedules);

    this.scheduleDialogService.bulkEditBreaks(highlightedShiftsCopy, event)
      .then((extraDataItemsPayload) => {
        this._onUpdateExtraDataItems(extraDataItemsPayload, this.configZoneId);
      })
  }

  _destroyRoutesBindings(ids) {
    _.forEach(ids, (id) => {
      if (this.routesRefList[id]) {
        this.routesRefList[id].$destroy();
        _.unset(this.routesRefList, id);
      }
    });
    if (!ids) {
      _.forOwn(this.routesRefList, (value, key) => {
        _.unset(this.routesRefList, key);
      })
    }

  }

  private _initPushesTimer() {
    this._destroyPushesTimer();

    this.pushesTimeoutRef = this.$timeout(() => {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;

      this.commonsDialogService.stillThereConfirm()
        .then((continueSession) => {
          if (continueSession) {
            this._initPushesTimer();

            //Sync Routes
            this._refreshRoutes();

          }
        })
    }, (this.maxUserIdleTimeMinutes * 60000));
  }

  private _destroyPushesTimer() {
    if (this.pushesTimeoutRef) {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;
    }
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentsScheduleViewNew', {
    bindings: {
      agents: '<',
      agentsGroup: '<?',
      from: '<?',
      to: '<?',
      size: '<?',
      page: '<?',
      branchIds: '<?',
      agentIds: '<?',
      serviceAreaIds: '<?',
      agentType: '<?',
      agentSkills: '<?',
      agentAssistant: '<?',
      isFavouriteAgentsMode: '<?',
      isSortMode: '<?',
      viewSettings: '<?',
      selectedQuickFilterId: '<?'
    },
    template: require('./agents-schedule-view-new.html').default,
    controller: AgentsScheduleViewNewCtrl
  });
